import type { FilterItem, FilterItemPascal, MvcLocation } from "@repo/models";
import type { GridList } from "@repo/ui";
import type { AxiosRequestConfig } from "axios";

import { BaseController, BaseGridApi } from "@repo/baseCloud";

import type { LocationsFilter } from "../models";

export const controller = "Locations";

export default class LocationsApi {
	static Get = BaseController.GetFn(controller);
	static Post = BaseController.PostFn(controller);

	// Grid
	static getLocations(filter: LocationsFilter, config?: AxiosRequestConfig) {
		return LocationsApi.Get<GridList<MvcLocation>>("GetLocations", filter, config);
	}
	// Dropdowns (Location Properties)
	static getBrands() {
		return LocationsApi.Get<FilterItemPascal[]>("GetBrands");
	}
	static getChannels() {
		return LocationsApi.Get<FilterItemPascal[]>("GetLocationChannels");
	}
	static getPartnerTypes() {
		return LocationsApi.Get<FilterItem[]>("GetLocationPartnerTypesDyn");
	}
	static getPartners(filters: { brandId?: any; channelId?: any; state?: any; partnerTypeId?: any }) {
		return LocationsApi.Get<FilterItem[]>("GetLocationPartnersDyn", filters);
	}
	static getCompanyDivisions() {
		return LocationsApi.Get<FilterItem[]>("GetCompanyDivisions");
	}

	// Address filters
	static getLocationStates(filters: { brandId?: any; channelId?: any; state?: any; partnerTypeId?: any }) {
		return LocationsApi.Get<FilterItemPascal[]>("GetLocationStates", filters);
	}

	// Branch filters
	static getBranchChannels() {
		return LocationsApi.Get<FilterItemPascal[]>("GetLocationChannels");
	}
	static getMarketers(filters: { channelId?: any; state?: any; marketer?: any; branchId?: any }) {
		return LocationsApi.Get<FilterItemPascal[]>("GetMarketers", filters);
	}
	static getStates(filters: { channelId?: any; state?: any; marketer?: any; branchId?: any }) {
		return LocationsApi.Get<FilterItemPascal[]>("GetStates", filters);
	}
	static getBranches(filters: { channelId?: any; state?: any; marketer?: any; branchId?: any }) {
		return LocationsApi.Get<FilterItemPascal[]>("GetBranches", filters);
	}

	/** Loads saved grid settings for locations */
	static loadGridSettings() {
		return BaseGridApi.loadGridSettings(controller, "Locations");
	}

	/** Saves grid settings for locations. Pass empty string to clear. */
	static saveGridSettings(settingsJson: string) {
		return BaseGridApi.saveGridSettings(controller, "Locations", settingsJson);
	}

	static getImportTypes() {
		return LocationsApi.Get<ImportType[]>("GetImportTypes");
	}

	static getMonths() {
		return LocationsApi.Get<FilterItemPascal[]>("GetMonths");
	}

	static getYears() {
		return LocationsApi.Get<FilterItemPascal[]>("GetYears");
	}

	static processLocationScheduleImportFile(formData: FormData) {
		return LocationsApi.Post<{ importLog: string }>("ProcessLocationScheduleImportFile", {}, formData);
	}

	static downloadLocationScheduleUploadTemplate(importType: string, year: string, month: string) {
		return LocationsApi.Get<Blob>(
			"DownloadLocationScheduleUploadTemplate",
			{ importType, year, month },
			{ responseType: "blob" },
		);
	}

	static saveLocationsFile(formData: FormData) {
		// The server reports a failed import as HTTP 200 with Type "Error".
		return LocationsApi.Post<{ Type: "Upload" | "Error"; FileName: string }>("SaveLocationsFile", {}, formData);
	}

	static getGridColumns() {
		return BaseGridApi.getGridColumns<any>(controller, "Locations");
	}
}

interface ImportType extends FilterItemPascal {
	Metadata: string;
}
